/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';
import { Breadcrumbs } from 'uikit/layouts';
import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import DraggableListItem from '../../nestedRows/components/draggableListItem';

import styles from '../styles/searchResultListItem.module.scss';

const itemPropTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    kebabMenuItems: PropTypes.arrayOf(PropTypes.shape({})),
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      path: PropTypes.string,
      key: PropTypes.number,
    })),
    tag: PropTypes.node,
  }).isRequired,
};

const ToggleExpandButton = () => null;

const Content = ({ item }) => {
  const {
    icon, iconClassName = '', name, url, breadcrumbs, tag
  } = item;

  return (
    <div className={`${styles.content} searchResultContent`}>
    {icon && createIconComponent({ icon, className: iconClassName, size: 20 })}
      <Link to={url} className={styles.link}>
        <Typo
          variant="s02"
          weight="medium"
          className={styles.title}
          title={name}
        >
          {name}
        </Typo>
      </Link>
      <Breadcrumbs breadcrumbs={breadcrumbs} className={styles.breadcrumbs} shouldShowAllAsActive />
      {tag}
    </div>
  );
};

Content.propTypes = itemPropTypes;

const KebabMenu = ({ item }) => {
  const { kebabMenuItems = [] } = item;

  if (!kebabMenuItems.length) return null;

  return (
    <Menu
      className={styles.kebab}
      shouldAnimate={false}
      component={(
        <Button
          size="xsmall"
          variant="ghost"
          icon={<MoreHoriz />}
        />
        )}
    >
      <ul>
        {kebabMenuItems}
      </ul>
    </Menu>
  );
};

const SearchResultListItem = ({
  className = '',
  components = {},
  item,
  listItemClassName = '',
  onKebabMenuItemClick = () => null,
  ...other
}) => (
  <li className={classnames(styles.element, className)}>
    <DraggableListItem
      className={listItemClassName}
      item={item}
      components={{
        DragHandle: () => null,
        NewItemHighlight: () => null,
        ToggleExpandButton,
        Content,
        KebabMenu,
        ...components,
      }}
      onKebabMenuItemClick={onKebabMenuItemClick}
      onActionItemClick={() => null}
      onExpand={() => null}
      onCollapse={() => null}
      provided={{
        innerRef: () => null,
        dragHandleProps: {},
        draggableProps: {},
        placeholder: null,
      }}
      snapshot={{
        isDragging: false,
      }}
      {...other}
    />
  </li>
);

SearchResultListItem.propTypes = {
  ...itemPropTypes,
  className: PropTypes.string,
  listItemClassName: PropTypes.string,
  components: PropTypes.shape({}),
  onKebabMenuItemClick: PropTypes.func,
};

export default React.memo(SearchResultListItem);
